"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPeriodicUnlockSchedule = exports.getUnlockSchedule = void 0;
const getUnlockSchedule = (options) => {
    const { vestingSchedule, pythTokenListTime, includePastPeriods } = options;
    if (vestingSchedule.fullyVested) {
        return {
            type: "fullyUnlocked",
            schedule: [],
        };
    }
    else if (vestingSchedule.periodicVestingAfterListing) {
        return {
            type: "periodicUnlockingAfterListing",
            schedule: (0, exports.getPeriodicUnlockSchedule)({
                balance: vestingSchedule.periodicVestingAfterListing.initialBalance,
                numPeriods: vestingSchedule.periodicVestingAfterListing.numPeriods,
                periodDuration: vestingSchedule.periodicVestingAfterListing.periodDuration,
                startDate: pythTokenListTime,
                includePastPeriods,
            }),
        };
    }
    else {
        return {
            type: "periodicUnlocking",
            schedule: (0, exports.getPeriodicUnlockSchedule)({
                balance: vestingSchedule.periodicVesting.initialBalance,
                numPeriods: vestingSchedule.periodicVesting.numPeriods,
                periodDuration: vestingSchedule.periodicVesting.periodDuration,
                startDate: vestingSchedule.periodicVesting.startDate,
                includePastPeriods,
            }),
        };
    }
};
exports.getUnlockSchedule = getUnlockSchedule;
const getPeriodicUnlockSchedule = (options) => {
    const { balance, startDate, periodDuration, numPeriods, includePastPeriods } = options;
    const unlockSchedule = [];
    const currentTimeStamp = Date.now() / 1000;
    for (let i = 0; i < numPeriods; i++) {
        const unlockTimeStamp = Number(startDate) + Number(periodDuration) * (i + 1);
        if (currentTimeStamp < unlockTimeStamp || includePastPeriods) {
            unlockSchedule.push({
                date: new Date(unlockTimeStamp * 1000),
                amount: balance / numPeriods,
            });
        }
    }
    return unlockSchedule;
};
exports.getPeriodicUnlockSchedule = getPeriodicUnlockSchedule;
